module.exports = __webpack_public_path__ + "img/insights-chart.5ee92844.png";